import React, { useEffect, useState } from "react";
import api from "../api/api";
import "./Dashboard.scss";
import {
  Cart,
  BoxSeam,
  People,
  CurrencyRupee
} from "react-bootstrap-icons";

function AdminDashboard() {

  const [stats, setStats] = useState({});

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    const res = await api.get("/Admin/dashboard");
    setStats(res.data);
  };

  return (
    <div className="dashboard-container container-fluid">

      <h4 className="dashboard-title">Admin Dashboard</h4>

      <div className="row">

        <div className="col-md-3 col-6">
          <div className="dashboard-card1 gradient-1">
            <Cart size={28}/>
            <h5>Total Orders</h5>
            <h3>{stats.totalOrders}</h3>
          </div>
        </div>

        <div className="col-md-3 col-6">
          <div className="dashboard-card1 gradient-2">
            <BoxSeam size={28}/>
            <h5>Total Products</h5>
            <h3>{stats.totalProducts}</h3>
          </div>
        </div>

        <div className="col-md-3 col-6">
          <div className="dashboard-card1 gradient-3">
            <People size={28}/>
            <h5>Total Users</h5>
            <h3>{stats.totalUsers}</h3>
          </div>
        </div>

        <div className="col-md-3 col-6">
          <div className="dashboard-card1 gradient-4">
            <CurrencyRupee size={28}/>
            <h5>Total Revenue</h5>
            <h3>₹{stats.revenue}</h3>
          </div>
        </div>

      </div>

      <div className="row mt-4">

        <div className="col-md-2 col-6">
          <div className="status-card gradient-2">Pending<br/><b>{stats.pending}</b></div>
        </div>

        <div className="col-md-2 col-6">
          <div className="status-card gradient-3">Confirmed<br/><b>{stats.confirmed}</b></div>
        </div>

        <div className="col-md-2 col-6">
          <div className="status-card gradient-4">Processing<br/><b>{stats.processing}</b></div>
        </div>

        <div className="col-md-2 col-6">
          <div className="status-card gradient-5">Shipped<br/><b>{stats.shipped}</b></div>
        </div>

        <div className="col-md-2 col-6">
          <div className="status-card gradient-6">Delivered<br/><b>{stats.delivered}</b></div>
        </div>

        <div className="col-md-2 col-6">
          <div className="status-card gradient-7">Cancelled<br/><b>{stats.cancelled}</b></div>
        </div>

      </div>

    </div>
  );
}

export default AdminDashboard;